import { Link } from "@material-ui/core";
import { FC } from "react";

const ListUrlField: FC<any> = ({ record, source }) => {
  const handleClickUrl = (e: any) => {
    e.stopPropagation();
    window.open(`${record[source]}/show`);
  };

  return (
    <>
      {record[source] ? (
        <Link color="primary" onClick={handleClickUrl}>
          {record[source]}
        </Link>
      ) : null}
    </>
  );
};

export default ListUrlField;
